import { BaseControl } from '../controls/base-control.model';

export class ViewRowControl {

  controls: BaseControl[] = [];
  extend: boolean = false; // Setting this to true will let the 1 control in this row extend over both spots
  hideRow: boolean = false;

  constructor() {

  }
}
